import React from 'react';
import { icons } from 'lucide-react';

/**
 * Resolve milestone icon from template.
 * Templates may store:
 * - Emoji strings (📄, 📬, 💳) → render as text
 * - Lucide component names ("FileText", "Send") → render as Lucide component
 * - null → return null
 */
export function MilestoneIcon({ 
  icon, 
  size = 16, 
  className 
}: { 
  icon: string | null | undefined; 
  size?: number;
  className?: string;
}) {
  if (!icon) return null;

  // Check if it's an emoji (contains non-ASCII characters)
  const isEmoji = /[\u{1F000}-\u{1FFFF}]|[\u{2600}-\u{27BF}]|[\u{FE00}-\u{FEFF}]|[\u{1F900}-\u{1F9FF}]|[\u{200D}]|[\u{20E3}]|[\u{E0020}-\u{E007F}]/u.test(icon);
  
  if (isEmoji) {
    return <span className={className} style={{ fontSize: size }}>{icon}</span>;
  }

  // Aliases for renamed/legacy icon names
  const ICON_ALIASES: Record<string, string> = {
    BarChart: 'ChartBar',
    BarChart2: 'ChartBar',
  };
  const resolvedIcon = ICON_ALIASES[icon] ?? icon;

  // Try to find as Lucide icon name
  const LucideIcon = (icons as Record<string, React.ComponentType<any>>)[resolvedIcon];
  if (LucideIcon) {
    return <LucideIcon size={size} className={className} />;
  }

  // Fallback: render as text
  return <span className={className} style={{ fontSize: size }}>{icon}</span>;
}
